<template>
  <div id="app">
    <router-view />
    <PwaInstallPrompt />
  </div>
</template>

<script setup lang="ts">
import PwaInstallPrompt from './components/PwaInstallPrompt.vue';
// Глобальные стили и логика
</script>

<style>
#app {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}
</style>